import styled, {css} from 'styled-components';

import {DeviceTypesEnum, PlatformProps, withPlatform} from '../platform/platformContext';
import {surveyFormTextAreaWidth} from '../survey/surveyForm';

/*
 * Constants.
 */

const mainContentWrapperPadding = 24;
// The width of this main content div can't be computed dynamically based on the
// contents because we want it to maintain the width after the form is submitted
// and the widest element (the text area) is no longer in the div
const mainContentDesktopWidth = 2 * mainContentWrapperPadding + surveyFormTextAreaWidth;

/*
 * Style.
 */

const StyledMainContentWrapper = styled.div<PlatformProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${mainContentWrapperPadding}px;
  background-color: white;
  border-radius: 18px;
  ${(props) => platformStyle(props)};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3), 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

function platformStyle(props: PlatformProps) {
  if (props.device === DeviceTypesEnum.DESKTOP) {
    return css`
      width: ${mainContentDesktopWidth}px;
      margin: 66px auto 48px auto;
      overflow-y: scroll;
    `;
  }

  return css`
    width: 92%;
    margin: 30px auto;
  `;
}

/*
 * Component.
 */

export const MainContentWrapper = withPlatform(StyledMainContentWrapper);
